__turbopack_context__.v({
  "closeIcon": "Share-module__0QsXra__closeIcon",
  "contentWrapper": "Share-module__0QsXra__contentWrapper",
  "iconWrapper": "Share-module__0QsXra__iconWrapper",
  "notificationWrapper": "Share-module__0QsXra__notificationWrapper",
});
